import SimpleBadge from "@/app/components/ui/Badges/SimpleBadge";
import ModalInformation from "@/app/components/ui/Modals/Information";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { XMarkIcon } from "@heroicons/react/20/solid";
import EditCustomerAndPetForm from "../../auth_routes/CustomerProfile/AddCustomer/EditCustomerAndPetForm";

export interface IBookingMissingDetailsEditModalState {
  customerId: string;
  petId: string;
  missingDetails: {
    pet: {
      count: number;
      keys: Array<string>;
    };
    customer: {
      count: number;
      keys: Array<string>;
    };
  };
}

const BookingMissingDetailsEditModal: React.FC<{ className?: string }> = () => {
  const { setInvisible } = useModalActions("BOOKING_MISSING_DETAILS_EDIT_MODAL");
  const { missingDetails } = useModalState(
    "BOOKING_MISSING_DETAILS_EDIT_MODAL",
  ) as IBookingMissingDetailsEditModalState;

  return (
    <ModalInformation
      persistent
      modalId="BOOKING_MISSING_DETAILS_EDIT_MODAL"
      dialogClassName="sm:my-8 sm:w-full sm:max-w-7xl sm:p-6 h-[700px] overflow-scroll"
      title={
        <div className="flex justify-start items-center w-full">
          <div>Update the following details</div>

          <div className="ml-2">
            {missingDetails?.customer?.keys?.map((key, idx) => {
              return (
                <SimpleBadge
                  colorClassName="text-rose-600 bg-rose-50 ring-rose-500/10"
                  label={key}
                  key={`${key}:${idx + 1}`}
                />
              );
            })}
          </div>

          <div className="ml-2 flex justify-start items-center gap-x-1">
            {missingDetails?.pet?.keys?.map((key, idx) => {
              return (
                <SimpleBadge
                  colorClassName="text-rose-600 bg-rose-50 ring-rose-500/10"
                  label={key}
                  key={`${key}:${idx + 1}`}
                />
              );
            })}
          </div>

          <div className="absolute top-3 right-0">
            <button onClick={() => setInvisible()}>
              {" "}
              <XMarkIcon className="w-6 h-6" />{" "}
            </button>
          </div>
        </div>
      }
    >
      <EditCustomerAndPetForm />
    </ModalInformation>
  );
};

export default BookingMissingDetailsEditModal;
